﻿/*global google, EdqResourceVersion */

// PLACEHOLDER Utilities object (can be removed when require.js or other AMD solution is available)
var Utilities = { breakpoint: { sm: 768 } };

var DataCoverage = {

    // Set by DataCoverage.config()
    elements: { containers: {}, lookup: {}, grades: {} },
    labels: {},
    colorScheme: "",
    config: function (elements, labels, colorScheme) {

        DataCoverage.elements = elements;
        DataCoverage.labels = labels;
        DataCoverage.colorScheme = colorScheme;

        $(function () {
            $(DataCoverage.elements.containers.main).inView(DataCoverage.init);
        });
    },

    // Create either the interactive map and table or the lookup dropdown, based on screen size
    init: function () {
        // Store the classname of the section that the chart or dropdown is in
        DataCoverage.setSectionClass();

        // Load Google Charts packages and run our drawMapAndTable function if device appears to be bigger than a phone
        if ($(window).width() > Utilities.breakpoint.sm && Modernizr.svg) {
            google.load("visualization", "1", {
                packages: ["geochart", "table"],
                callback: DataCoverage.drawMapAndTable
            });
        }
            // Otherwise, use a fallback which improves usability on small screens
        else {
            $(function () {
                $(DataCoverage.elements.containers.map + "," + DataCoverage.elements.containers.table + "," +
                  DataCoverage.elements.grades.all + "," + DataCoverage.elements.containers.lookup)
                    .toggleClass("hidden");
                DataCoverage.drawLookup();
            });
        }
    },

    setSectionClass: function () {
        DataCoverage.sectionClass = $(DataCoverage.elements.containers.map).eq(0).closest(".section").attr("class");
        if (typeof DataCoverage.sectionClass === "undefined") {
            DataCoverage.sectionClass = "";
        }
    },

    // Lookup extension to get data grade as an int, a tooltip label or a sortable HTML string
    getGrade: {
        int: function (grade) {
            var gradeInt = 1;
            gradeInt = (grade === "A+") ? 3 : gradeInt;
            gradeInt = (grade === "A") ? 2 : gradeInt;
            gradeInt = (grade === "B") ? 1 : gradeInt;
            return gradeInt;
        },
        label: function (grade) {
            return DataCoverage.labels.coverageGrade + ": " + grade;
        },
        sortable: function (grade) {
            var sortedGrade = grade;
            var sortHtml = function (sortIndex) {
                return "<span data-sortorder='" + sortIndex + "'></span>";
            };
            sortedGrade = (grade === "A+") ? sortHtml(1) + grade : sortedGrade;
            sortedGrade = (grade === "A") ? sortHtml(2) + grade : sortedGrade;
            sortedGrade = (grade === "B") ? sortHtml(3) + grade : sortedGrade;
            return sortedGrade;
        }
    },

    // Lookup extension to get a sortable HTML string including a lazily-loaded SVG flag and accompanying country name
    getFlagTitle: function (countryIso2, countryName) {
        var flagSrc = EdqResourceVersion + "/images/flags/" + countryIso2.toLowerCase() + ".svg",
            lazyImageHtml = Utilities.lazyImage(flagSrc, countryName, { "class": "inline-flag" }),
            flagTitleHtml = "<span data-countryname='" + countryName + "'>" +
                                lazyImageHtml +
                                countryName +
                            "</span>";

        return flagTitleHtml;
    },

    // Get the list of countries, sorted by friendly name
    sortedCountries: function () {
        return DataCoverage.countries.sort(Utilities.sortData("name"));
    },

    // Set up and render the interactive map and table
    drawMapAndTable: function () {

        /* Global Setup      */

        // Progress function: runs the complete function when all charts are drawn
        var progress = {
            counter: 2,
            chartComplete: function () {
                progress.counter--;
                if (progress.counter <= 0) {
                    DataCoverage.complete();
                }
            }
        };

        /* Map Setup      */
        
        // Set up the chart's data table (add columns)
        var chartData = new google.visualization.DataTable();
        chartData.addColumn("string", DataCoverage.labels.country);
        chartData.addColumn("number", "Value");
        chartData.addColumn({ type: "string", role: "tooltip" });

        // Set chart options (colours vary based on container's section class)
        var chartColors = ["#b0def8", "#0094da"];
        var datalessRegionColor = "#e5e5e5";

        
        // Change chart colours when against a dark blue background
        if (DataCoverage.sectionClass.indexOf("primary") !== -1) {
            chartColors = ["#6EB8E2", "#0267C6"];
            datalessRegionColor = "#B0DEF8";
        } else {
            if(DataCoverage.colorScheme === 'pink') {
                chartColors = ["#F6D4E7", "#D473A9"];
            }
        }

       
    
        var chartOptions = {
            colorAxis: {
                colors: chartColors
            },
            legend: "none",
            backgroundColor: {
                stroke: "#fff", fill: "transparent"
            },
            datalessRegionColor: datalessRegionColor
        };

        /* Table Setup    */

        // Set up the table (add columns)
        var tableData = new google.visualization.DataTable();
        tableData.addColumn("string", DataCoverage.labels.country);
        tableData.addColumn("string", DataCoverage.labels.coverageGrade);

        // Set table options
        var tableOptions = {
            sortColumn: 1,
            allowHtml: true,
            backgroundColor: {
                fill: "transparent"
            }
        };

        /* Data Population */

        // Add a row for each country
        $.each(DataCoverage.sortedCountries(), function (index, country) {
            // Add row to the chart's data table
            chartData.addRows([[
                {
                    v: country.iso2, f: country.name
                },
                DataCoverage.getGrade.int(country.grade),
                DataCoverage.getGrade.label(country.grade)]
            ]);
            // Add row to the table
            tableData.addRows([[
                DataCoverage.getFlagTitle(country.iso2, country.name),
                DataCoverage.getGrade.sortable(country.grade)
            ]]);
        });

        /* Rendering     */

        // Draw the chart and insert it in the chart div
        var chart = new google.visualization.GeoChart(document.getElementById($(DataCoverage.elements.containers.map).attr("id")));
        google.visualization.events.addListener(chart, "ready", progress.chartComplete);
        chart.draw(chartData, chartOptions);

        // Draw the table and insert it in the table div
        var table = new google.visualization.Table(document.getElementById($(DataCoverage.elements.containers.table).attr("id")));
        google.visualization.events.addListener(table, "ready", function () {
            progress.chartComplete();
        });
        table.draw(tableData, tableOptions);

        /* Resize event  */

        // If the window is resized, redraw the map and table to fit (but no more than every second)
        var timer;
        function resizeEnd() {
            DataCoverage.drawMapAndTable();
        }
        $(window).resize(function () {
            clearTimeout(timer);
            $(DataCoverage.elements.containers.map).children().fadeOut();
            $(DataCoverage.elements.containers.main).toggleLoaders("fadeIn");
            timer = setTimeout(resizeEnd, 1000);
        });
    },

    // Set up and render the lookup and dropdown
    drawLookup: function () {

        var $select = $(DataCoverage.elements.lookup.selector),
            $option;

        // Add a border to the dropdown if on a white background
        if (DataCoverage.sectionClass === "") {
            setTimeout(function () {
                $(DataCoverage.elements.containers.lookup).find(".dropdown button").attr("style", "border: 2px solid #ddd !important");
            }, 10);
        }

        // Create a dropdown which includes all countries
        $.each(DataCoverage.sortedCountries(), function (index, country) {
            $option = $("<option/>", {
                "value": country.iso2,
                "data-iso3": country.iso3,
                "data-iso2": country.iso2,
                "data-grade": country.grade,
                text: country.name
            });
            $select.append($option);
        });

        // Display country stats on selection
        $select.change(function () {
            var $selection = $(this).find(":selected"),
                selected = {
                };

            if ($selection[0].value !== "") {

                // Get data values for selected country
                selected.name = $selection[0].label;
                selected.iso2 = $selection.data("iso2");
                selected.iso3 = $selection.data("iso3");
                selected.grade = $selection.data("grade");

                // Populate the onscreen values
                $(DataCoverage.elements.lookup.country.name).text(selected.name);
                $(DataCoverage.elements.lookup.country.iso2).text(selected.iso2);
                $(DataCoverage.elements.lookup.country.iso3).text(selected.iso3);
                $(DataCoverage.elements.lookup.country.grade).text(selected.grade);

                // Reveal only the relevant coverage definition
                $(DataCoverage.elements.grades.single).find("[data-grade]").addClass("hidden");
                $(DataCoverage.elements.grades.single).find("[data-grade='" + selected.grade + "']").removeClass("hidden");

                // Show the coverage information
                $(DataCoverage.elements.lookup.results).removeClass("hidden");
            }
            else {
                // Hide the coverage information
                $(DataCoverage.elements.lookup.results).addClass("hidden");
            }
        });

        // Render the dropdown
        $select.removeClass("hidden");
        DataCoverage.complete();

        // Get the user's location and select the country they are in
        Utilities.geolocation.runAfter(function () {
            $select.val(Utilities.geolocation.current).change();
        });
    },

    // Function to run once rendering is complete
    complete: function () {
        $(DataCoverage.elements.containers.main).toggleLoaders("fadeOut");
    }
};